import React from 'react';
import ReactDOM from 'react-dom/client';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import App from './App';
import { FinancialConfirmationDialog } from './components/FinancialConfirmationDialog';
import { AppProviders } from './providers/AppProviders';
import './styles.css';
import './tailwind.css';

// Locale française globale pour dayjs (dates « 10 nov. », délais « il y a 2 j »).
dayjs.locale('fr');

// L'ancienne console `admin/`, servie sous permio.fr/admin/ jusqu'à son retrait, gardait un jeton
// super_admin dans ce navigateur : il est effacé à la première ouverture du logiciel.
try {
  window.localStorage.removeItem('pmd-admin-token');
} catch {
  // Stockage indisponible (navigation privée) : rien à effacer.
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <AppProviders>
      <App />
      <FinancialConfirmationDialog />
    </AppProviders>
  </React.StrictMode>,
);
